import LexiModel from "@/assets/lexi-model.jpg";
import { BarChart3, Layers, MessageCircle } from "lucide-react";
import { IconBadge } from "@/components/ui/icon-badge";
import { raceDayTipsTime } from "@/utils/time-format";

/**
 * HowItWorksSection component displaying the three main features of LEXI
 * with a negative margin top to create overlap with the hero section
 */
function HowItWorksSection() {
  // Owner, 2 Nov 2026: no "Feature coming soon!" items; what Lexi does today.
  // Race Day time in Sydney time with its zone, like /lexi-pro ("11:00 am AEDT" in daylight saving)
  const raceDayTime = raceDayTipsTime();
  const features = [
    {
      icon: BarChart3,
      title: "Lexi reads every race",
      description:
        "Tens of thousands of data points: the form, the track and the prices, for every Australian thoroughbred race.",
    },
    {
      icon: Layers,
      title: "Three looks at every race",
      description:
        `Early Mail up to 3 days out, Race Day tips by ${raceDayTime} and Late Mail minutes before the jump.`,
    },
    {
      icon: MessageCircle,
      title: "Ask Lexi, then check the results",
      description:
        "Chat to Lexi about any race, and see every result beside her tips on the public Race Results page.",
    },
  ];

  return (
    <section
      id="howitworks"
      className="relative mt-[-160px] lg:mt-[-300px] bg-black text-white pt-[240px] lg:pt-[420px] pb-24 px-4"
    >
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 text-white">How it works</h2>
          <p className="text-gray-300 max-w-2xl mx-auto">
            <span className="text-brand-pink font-bold">LEXI</span> analyses
            tens of thousands of data points to create her tips:{" "}
            <span className="text-white">
              Early Mail, Race Day tips and Late Mail for every race.
            </span>{" "}
            Read them, then chat to{" "}
            <strong className="text-brand-pink">LEXI</strong> about any race.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-6"
            >
              <IconBadge icon={feature.icon} tone="dark" className="mb-4" />
              <h3 className="text-xl font-semibold mb-2 text-white">
                {feature.title}
              </h3>
              <p className="text-gray-400">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Introducing LEXI Section */}
        <div id="meetlexi" className="mt-32 max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-1 gap-12 items-center">
            <div className="space-y-6 max-w-[900px] mx-auto">
              <h2 className="text-4xl font-bold text-center ">
                Introducing LEXI
              </h2>
              <p className="text-gray-300 leading-relaxed text-center">
                LEXI, our{" "}
                <span className="text-brand-pink font-bold">
                  Learned EXpert Intelligence
                </span>
                , is an AI tipster built for Australian thoroughbred racing.
                She works through the form, the track and the prices for every
                race, then gives her tips three times: Early Mail up to 3 days
                out, Race Day tips by {raceDayTime} and Late Mail minutes
                before the jump. Ask her about any race in Lexi Chat and she
                answers in plain words. Lexi.tips is a tipping information
                service: we don&apos;t take bets, and Lexi&apos;s tips are
                there for you to weigh&nbsp;up.
              </p>

              {/* Stats */}
            </div>
            {/* <div className="relative">
              <img
                src={LexiModel}
                alt="LEXI AI Assistant"
                className="rounded-3xl w-full"
              />
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default HowItWorksSection;
